import UltMeta, { Meta } from "./UltMeta/index";

class PushResult extends UltMeta {
    SUCCESS = new Meta(1, "成功");
    FAIL = new Meta(0, "失败");
}

export const PUSH_RESULT = new PushResult();
